import * as React from "react";
const SvgFiBrandsFonts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-fonts_svg__a)">
      <path
        fill="#151A2D"
        d="M20.573.3H4.427C1.982.3 0 2.203 0 4.55v14.9c0 2.347 1.982 4.25 4.427 4.25h16.146c2.445 0 4.427-1.903 4.427-4.25V4.55C25 2.203 23.018.3 20.573.3m-3.37 6.61c-.253 0-.379-.181-.458-.438-.268-.97-.616-1.257-.82-1.257-.205 0-.52.364-.868 1.12-.458.955-.765 1.994-1.05 2.994l1.805-.002c.11.212.02.65-.248.772H13.78c-.583 1.878-1.075 3.688-1.658 5.46-.331 1-.694 1.954-1.152 2.559-.505.68-1.451 1.333-2.588 1.333-.804 0-1.593-.363-1.593-1.166 0-.5.536-.97.962-.97a.48.48 0 0 1 .442.243c.395.68.773 1.075.947 1.075s.315-.227.6-1.211l2.07-7.322-1.49-.002c-.11-.318.048-.7.236-.775h1.484c.284-.878.618-1.776 1.091-2.58.71-1.225 1.846-2.195 3.407-2.195 1.184 0 1.674.546 1.674 1.242-.016.743-.694 1.12-1.01 1.12"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-fonts_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFonts;
